import { StyleRulesCallback, WithStyles, withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

const drawerWidth = '50%';

const styles: StyleRulesCallback = (theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        'align-items': 'center',
        backgroundColor: theme.palette.background.default,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
        height: 68,
        paddingLeft: 27,
        width: '100%',
    },
    title: {
        display: 'inline-block',
        lineHeight: 'normal',
        color: '#000',
    },
    contentWrapper: {
        width: '100%',
        overflowX: 'hidden',
    },
    buttonsWrapper: {
        marginTop: theme.spacing.unit * 2,
    },
});

interface DrawerWrapperProps extends WithStyles<typeof styles>, WrappedComponentProps {
    children: React.ReactNode;
    name: React.ReactElement;
    term: React.ReactElement;
    isShown: boolean;
    onClose: React.ReactEventHandler<HTMLElement> | undefined;
    onConfirm: React.MouseEventHandler<HTMLElement> | undefined;
    title: React.ReactElement;
    confirmDisabled?: boolean;
    displayButtons?: boolean;
}


const DrawerWrapper = ({
    classes,
    children,
    title,
    name,
    term,
    isShown,
    onClose,
    onConfirm,
    confirmDisabled = false,
    displayButtons = true,
}: DrawerWrapperProps) => (
    <Grid className={classes.root}>
        <Drawer
            className={classes.drawer}
            classes={{
                paper: classes.drawerPaper,
            }}
            anchor="right"
            open={isShown}
            onClose={onClose}
        >
            <Grid className={classes.contentWrapper}>
                {title && (
                    <header className={classes.header}>
                        <Typography variant="h6" className={classes.title}>
                            {title}
                        </Typography>
                    </header>
                )}

                {children}

                {displayButtons && (
                    <Grid
                        id="yeself-drawer-wrapper"
                        container
                        justify="center"
                        alignItems="center"
                        direction="row"
                        className={classes.buttonsWrapper}
                    >
                        <Typography>
                            <Button
                                id="yeself-cancle-button"
                                style={{ color: 'rgba(0, 0, 0, 0.38)', marginRight: '1.3rem' }}
                                onClick={onClose}
                            >
                                {name}
                            </Button>
                        </Typography>
                        <Typography>
                            <Button
                                id="yeself-button"
                                disabled={confirmDisabled}
                                variant="contained"
                                color="primary"
                                onClick={onConfirm}
                            >
                                {term}
                            </Button>
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </Drawer>
    </Grid>
);

export default withStyles(styles)(injectIntl(DrawerWrapper));
